import type React from 'react'
import TextInput from '../../../components/FormElements/TextInput'
import { useFormContext } from 'react-hook-form'

export const BasicInfoStep: React.FC = () => {
  return (
    <div className="flex flex-col gap-3">
      <TextInput required name="first_name" label="First Name" />
      <TextInput required name="last_name" label="Last Name" />
      <TextInput
        required
        name="email"
        label="Email"
        type="email"
        rules={{
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Invalid email address',
          },
        }}
      />
      <TextInput
        name="phone"
        label="Phone Number (Optional)"
        rules={{
          pattern: {
            value: /^[0-9]{10}$/,
            message: 'Please enter a valid 10-digit phone number',
          },
        }}
      />
    </div>
  )
}
